import Styled from 'styled-components';

const namespace = 'loading-message';

interface LoadingMessageContainerProps {
  isMobile?: boolean;
  width?: 'string' | 'auto';
} 

export const LoadingMessageContainer = Styled.div<LoadingMessageContainerProps> `
  transition: all 0.7s ease-in-out;
  width: ${(props) => props.width || 'auto' };
  text-align: center;

  ${(props) => props.isMobile && (
    'width: auto; text-align: center; padding: 0 50px;'
  )}

  .${namespace}-gif {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    ion-img::part(image) {
      border-radius: 100px;
      width: 250px;
      margin-top: -25px;
    }

    ${(props) => props.isMobile && (
      'display: inline-block; width: 20%; height: 60px; margin: 32px 0;'
    )}
  }
`;